export enum DomainItems {
  Warehouse = 1,
  ShippingMethod = 2,
    BillingTypes = 3,
  COAs = 4,
}
